<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card
      v-if="accounts.length > 0"
      :title="$t('pamm_own_account')"
    >
      <h5 class="my-2">
        {{ $t('pamm_own_account_description') }}
      </h5>
      <b-row>
        <b-col
          v-for="account in accounts"
          :key="account.id"
          cols="12"
          md="6"
          xl="4"
          class="mb-2"
        >
          <MyAccountCard :account="account" />
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row align-h="between">
        <b-col
          cols="auto"
          class="d-flex align-items-center"
        >
          {{ $t('create_pamm_here_title') }}
        </b-col>
        <b-col cols="auto">
          <b-button
            :to="{ name: 'pamm_management_create' }"
            variant="primary"
          >
            {{ $t('pamm_account_create') }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>

  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import PammApis from '@/modules/pamm/service/apis'
import MyAccountCard from '../components/my-account-card.vue'

const pammApis = new PammApis()

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    MyAccountCard,
  },
  data() {
    return {
      show: false,
      accounts: [],
    }
  },
  mounted() {
    this.getAccounts()
  },
  methods: {
    async getAccounts() {
      this.show = true
      await pammApis.getManagerList().then(res => {
        const { results } = res.data
        this.accounts = Array.isArray(results) ? results : (results?.data ?? [])
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.show = false
      })
    },
  },
}
</script>

<style>
.pamm-button{
  background: linear-gradient(180deg, #068787 0%, #0A9292 48.96%, #035C68 100%) !important ;
  border:none !important ;
}
</style>
